import { MemberImportSession } from 'src/modules/member/models/memberImportSession';
import AxiosInstance from 'src/shared/services/axios/interceptor';

const controller = 'MemberImportSession';

export const getImportSessions = (pageIndex = 0, pageSize = 50) => {
  return AxiosInstance.get<MemberImportSession[]>(`${controller}?pageIndex=${pageIndex}&pageSize=${pageSize}`);
};

export const acceptImportSession = (id: number) => {
  return AxiosInstance.put(`${controller}/Accept/${id}`);
};

export const rejectImportSession = (id: number) => {
  return AxiosInstance.put(`${controller}/Reject/${id}`);
};
